import React from 'react'

import { ShippingCards, ShippingCardsProps } from '../../components-hydrated/shipping-cards/shipping-cards.js'
import { Checkbox, CheckboxProps } from '../forms/checkbox/checkbox.js'
import { Textfield, TextfieldProps } from '../forms/textfield/textfield.js'
import { GridColumn } from '../grid/grid-column.js'
import { Grid } from '../grid/grid.js'
import { Separator } from '../separator/separator.js'

export interface SignProps {
    firstNameField: TextfieldProps
    lastNameField: TextfieldProps
    emailField: TextfieldProps
    phoneField: TextfieldProps
    postField: TextfieldProps
    addressField: TextfieldProps
    cityField: TextfieldProps

    acceptTerms: CheckboxProps

    shippingTitle: string
    // TEMP: Lock shipping if defined by scrive
    differentShippingAddress?: CheckboxProps
    differentShippingFields?: TextfieldProps[]
    shippingMethods: ShippingCardsProps
}

export const SignStep = (props: SignProps): JSX.Element => (
    <>
        <Grid>
            <GridColumn width={['md-6', 'xs-4']}>
                <Textfield {...props.firstNameField} />
            </GridColumn>
            <GridColumn width={['md-6', 'xs-4']}>
                <Textfield {...props.lastNameField} />
            </GridColumn>
            <GridColumn width={['md-6', 'xs-4']}>
                <Textfield {...props.emailField} />
            </GridColumn>
            <GridColumn width={['md-6', 'xs-4']}>
                <Textfield {...props.phoneField} />
            </GridColumn>
            <GridColumn width={['md-6', 'xs-4']}>
                <Textfield {...props.postField} />
            </GridColumn>
            <GridColumn width={['md-6', 'xs-4']}>
                <Textfield {...props.addressField} />
            </GridColumn>
            <GridColumn width={['xs-4']}>
                <Textfield {...props.cityField} />
            </GridColumn>
        </Grid>
        <Separator invisible={true} />
        <Grid>
            <GridColumn>
                <div className="text">
                    <strong>{props.shippingTitle}</strong>
                </div>
            </GridColumn>
            {props.differentShippingAddress && (
                <GridColumn>
                    <Checkbox {...props.differentShippingAddress} />
                </GridColumn>
            )}
            {props.differentShippingFields && props.differentShippingFields.length > 0 && (
                <GridColumn width={['md-6', 'xs-4']}>
                    <Grid>
                        {props.differentShippingFields.map((shippingField) => (
                            <GridColumn key={shippingField.id}>
                                <Textfield {...shippingField} />
                            </GridColumn>
                        ))}
                    </Grid>
                </GridColumn>
            )}
            <GridColumn width={['xs-4']}>
                <ShippingCards {...props.shippingMethods} />
            </GridColumn>
        </Grid>
        {props.acceptTerms && (
            <>
                <Separator invisible={true} />
                <Grid>
                    <GridColumn width={['xs-4']}>
                        <Checkbox {...props.acceptTerms} />
                    </GridColumn>
                </Grid>
            </>
        )}
    </>
)
